<template>
    <div class="rest_list stop_list">
        <div class="rest_list__search">
            <search_block
                :key="'search_block_menu_stop_list'"
                :placeholderText="placeholderTextSearch"
                :searchDataDefault="searchDataMenu"
                @search_input_data="searchInputData"
            />
            <div class="rest_list__search_switch">
                <div class="rest_list__search_switch_img">
                    <switch_block
                        :key="'switch_block_'"
                        :switchStatus="isSearchModifier"
                        :width="52"
                        :height="32"
                        @click_switch="clickSearchSwitch"
                    />
                </div>
                <div class="rest_list__search_switch_label"  @click.prevent="clickSearchSwitch">
                    {{ __t('O.SEARCH_BY_MODIFIER') }}
                </div>
            </div>
        </div>
        <spinner
            v-if="isLoadedSelectAggregatorsLocationsAll"
            :height="'100px'"
            :width="'10px'"
        />
        <div v-else class="rest_list__scroll products">
            <div ref="blockScroll" class="rest_list__scroll_container">
                <spinner
                    v-if="isLoadMenu"
                    :height="'100px'"
                    :width="'10px'"
                />
                <rest_list_item_product
                    v-else
                    v-for="item in productsListMenu"
                    :key="'rest_list_item_product_' + itemProductId(item)"
                    :prodItem="item"
                    :isStopListItem="isStopListMenu"
                />
            </div>
        </div>

        <div v-if="!isLoadedSelectAggregatorsLocationsAll" class="rest_list__buttons">
            <div class="rest_list__buttons_container">
                <button class="rest_list__buttons_button_off" @click.prevent="clickSelectAll">
                    <div class="rest_list__buttons_button_off_text">
                        {{ __t('O.SELECT_ALL') }}
                    </div>
                </button>
                <button class="rest_list__buttons_button_on" @click.prevent="clickSelectStopListProducts">
                    <div class="rest_list__buttons_button_on_text">
                        {{ __t('O.NEXT') }}
                    </div>
                </button>
            </div>
        </div>
    </div>

</template>

<script>

import rest_list_header_item from "../../RestListHeaderItem.vue";
import search_block from "../../SearchBlock.vue";
import modal from "../../../modal/Modal.vue";
import modal_filter from "../../../modal/filter/ModalFilter.vue";
import spinner from "../../../loader/Spinner.vue";
import switch_block from "../../SwitchBlock.vue";
import {createHelpers} from "vuex-map-fields";
import burger_menu from "../../../heading/BurgerMenu.vue";
import spinner_button from "../../../loader/SpinnerButton.vue";
import rest_list_item_product from "./RestListItemProduct.vue";
import menu_orders from "../../../menu/order/MenuOrders.vue";
import button_up from "../../../ButtonUp.vue";
import counter_list from "../../../CounterList.vue";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})
const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})

export default {
    name: "products_select_stop_list",
    props: {
        backState: {
            type: String,
            required: false,
            default: '0'
        },
    },
    emits: [],
    mixins: [],
    components: {
        menu_orders,
        spinner_button,
        burger_menu,
        rest_list_header_item,
        search_block,
        modal,
        modal_filter,
        spinner,
        switch_block,
        rest_list_item_product,
        button_up,
        counter_list
    },
    data() {
        return {
            showBlockButtons: false,
            isLoadMenu: false,
            productsListMenuNoFilter: [],
            productsListMenu: [],
            filterList: [],
            filterListProduct: [],
            searchDataMenu: '',
            statusModalProductLocations: false,
            productSelect: null,
            counterLabel: '500',
            counterCurrent: 0,
            counterTotal: 0,
            isSearchModifier: false,
        }
    },
    beforeMount() {
        EventBus.$on('load_search_products_menu', this.loadSearchProductsMenu);
        if (parseInt(this.backState) === 1) {
            this.loadSearchProductsMenu();
        }
    },
    beforeUnmount() {
        EventBus.$off('load_search_products_menu', this.loadSearchProductsMenu);
    },
    methods: {
        itemProductId(item) {
            if (item.id) {
                return item.id;
            }
            if (item.product.id) {
                return item.product.id;
            }
            return '';

        },
        clickSearchSwitch() {
            this.isSearchModifier = !this.isSearchModifier;
            this.searchInputData(this.searchDataStopListFast);
        },
        getProductsListMenu() {
            this.productsListMenu = this.productsListMenuNoFilter;
        },
        clickSelectStopListProducts() {
            const selectProducts = this.productsListMenu.filter(item => item.isCheck);
            this.$store.dispatch('stop_list/SET_SELECT_PRODUCTS_STOP_LIST', selectProducts);
            this.$router.push({path: '/fast_stop_list/locations', name: 'FastStopListLocations'})
        },
        loadSearchProductsMenu() {
            this.productsListMenuNoFilter = this.searchProductsMenuStopList;
            this.filterList = this.searchProductsMenuFilter;
            this.productsListMenuNoFilter = this.searchProductsMenuStopList;
            this.searchDataMenu = this.searchDataStopListFast;
            this.getProductsListMenu();
            this.isLoadMenu = false;
        },
        searchInputData(searchData) {
            if (searchData.length <= 2) {
                this.isLoadMenu = false;
                this.productsListMenu = [];
                return;
            }
            this.isLoadMenu = true;
            this.$store.dispatch('stop_list/SEARCH_PRODUCTS_MENU', {
                searchData: searchData,
                isSearchModifier: this.isSearchModifier,
                actionName: 'searchProductsMenu',
            });
        },
        compareTitles(a, b) {
            if (a.product && a.product.title && b.product && b.product.title) {
                const nameA = a.product.title.toLowerCase();
                const nameB = b.product.title.toLowerCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
            }
            return 0;
        },
        clickSort() {
            this.productsListMenu.sort(this.compareTitles);
            this.getProductsListMenu(this.productsListMenu);
        },
        clickSelectAll() {
            this.productsListMenu.forEach(item => item.isCheck = true);
        },
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
        ]),
        ...mStopList([
            'stopListProducts',
            'searchProductsMenuStopList',
            'searchDataStopListFast',
            'stopListProductsFilter',
            'searchProductsMenuFilter',
            'isLoadedSelectAggregatorsLocationsAll',
        ]),
        placeholderTextSearch() {
            return `${this.__t('O.FOOD_SEARCH')}`;
        },
        isStopListMenu() {
            return false;
        },
        filterLocationsId() {
            return this.filterList
                .filter(item => item.isCheckSave === true)
                .map(item => item.id)
        },
    },
}
</script>
